export default {
  dialogTitle: "Uploads",
  state: {
    queued: "Ausstehend",
    uploading: "Lädt hoch... ({{progress}} Prozent)",
    failed: "Fehlgeschlagen",
    finished: "Abgeschlossen"
  }
};
